 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-178f0da1":"62368951","chunk-1a0a2d9f":"3cc93689","chunk-003011cf":"9308c005","chunk-0030172f":"46dec0af","chunk-0030878f":"f75e2c9b","chunk-0030970e":"0fc3f978","chunk-0030bd62":"4a8aa862","chunk-0030eabd":"3f9b4c81","chunk-0030f6c9":"4ebdd05f","chunk-00312a7d":"e46ff89d","chunk-00313b92":"1b3776f2","chunk-0031777f":"15428e7b","chunk-0031a89a":"f0a73f68","chunk-0031d415":"2edd237f","chunk-0031dda4":"e6ef17f0","chunk-00324c42":"d8bbc87f","chunk-00325139":"550e65da","chunk-003294fb":"6e4db485","chunk-00329c7d":"475f3b25","chunk-0032bcb4":"bd3b624b","chunk-003307b3":"811cd612","chunk-00330be4":"175b381b","chunk-003329c2":"0ba829f2","chunk-003341b7":"17c70ec3","chunk-00334435":"8999c7c2","chunk-0033b2b7":"cc02ffc0","chunk-0033f618":"897477bd","chunk-003417e1":"774819e6","chunk-00342aa6":"5ec9dbb8","chunk-0034dc3e":"42feeaef","chunk-00464c4b":"7fa43ba3","chunk-00464cb4":"f2216df0","chunk-004651af":"3018bbee","chunk-004660cf":"357a91d7","chunk-0046bd51":"b715f6b3","chunk-00473e88":"95164ab7","chunk-0047b650":"9113dedc","chunk-0047b876":"848a9f4a","chunk-00481f6d":"7d521675","chunk-0048a8cc":"3a7f578f","chunk-0048d804":"1342cca1","chunk-00494e18":"edbfd934","chunk-1cc91e69":"8e71e354","chunk-36306126":"b514e63d","chunk-5ba900e4":"dcd5ac8d","chunk-2d222538":"69124946","chunk-2d2257e2":"c281d8b9","chunk-66f9b0c0":"ce31243a","chunk-7756441f":"3e76bdde","chunk-1fb322a0":"9f863a8c","chunk-273822c8":"d0e240b4","chunk-1fb5236e":"a3b9cb1b","chunk-2a10fa14":"02e55485","chunk-7ac7242a":"ac69e8d3","chunk-2c1f1eda":"6e7d4a6b","chunk-2d0e28f8":"c8c92f87","chunk-7ac7532e":"0ae08af5","chunk-154dda1d":"7c8ef541","chunk-bbb1db96":"69b2bba7","chunk-2d225769":"3cc3eb67","chunk-b3204efa":"db26cfb8","chunk-2d0aa641":"0fb87de4","chunk-2d0cebbf":"94d5816d","chunk-2d0d32d2":"0db8810e","chunk-2d0e9b9e":"afb038ec","chunk-2d208352":"beab5dcf","chunk-2d230b9f":"9300b941","chunk-335b5112":"f0d667de","chunk-0db8ed08":"2ae24689","chunk-2d0c4e47":"2836df9b","chunk-2d22939a":"1ef2ca26","chunk-316e3566":"11027ca3","chunk-2d0af0d7":"8258b2a6","chunk-2d0b5d57":"60516af0","chunk-2d0c4f98":"07a0da74","chunk-2d0cbe65":"8cd85cdd","chunk-2d0d7360":"e6f723d2","chunk-2d0da514":"a27d0296","chunk-2d0e2944":"a60fb949","chunk-2d0f0a3e":"c76cbd3d","chunk-2d207b27":"37a3de8d","chunk-2d21023c":"62d82df3","chunk-2d2107da":"649ac0f3","chunk-2d2183d1":"651e6a08","chunk-2d21d8c5":"9eb9262c","chunk-2d22690b":"d115385d","chunk-2d226938":"87b37d68","chunk-35e6bb01":"9523b610","chunk-37165250":"6d26ebfb","chunk-3afdab94":"19249666","chunk-40deda2d":"9c60e0a1","chunk-41722a50":"e5100e16","chunk-41862e60":"4007022b","chunk-66dc6f97":"11a4d940","chunk-8fc3fc8c":"e4303dde","chunk-98683b70":"bc4f80d3","chunk-af05546c":"1099bd27","chunk-db83d184":"cc70841c","chunk-db850552":"81a8f7fe","chunk-dbb279da":"71c2c9bd","chunk-8eda5d04":"6c0f30c3","chunk-b1b27428":"5837c28f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/PURPLEadmin/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
